import Joi from '@hapi/joi'

export const NormAssignListingSchemaObject = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Group required`,
    }),
    estate: Joi.array().min(1).required().label("Operation Entity").messages({
        "array.min": `Operation Entity is required`,
        "any.required": `Operation Entity is required`,
    }),
    configurationID: Joi.number().invalid(0).required().label("Configuration Name").messages({
        "any.invalid": `Configuration Name is required`,
    }),
    divisionID: Joi.array().min(1).required().label("Collection Point").messages({
        "array.min": `Collection Point is required`,
        "any.required": `Collection Point is required`,
    }),
    fromDate: Joi.string().invalid("").required().label("From Date").messages({
        "any.required": `From Date required`,
    }),
    toDate: Joi.string().invalid("").required().label("To Date").messages({
        "any.required": `To Date required`,
    }),
}

export const NormAssignSchemaObjectUpdate = {
    configurationValue: Joi.string().allow('').pattern(/^[0-9]+$/).optional().label("configurationValue").messages({
        "string.pattern.base": `configurationValue must be a positive integer with no special characters or decimals`,
    }),
    minValue: Joi.number().integer().greater(0).required().label("minValue").messages({
        "number.base": `Min Value must be a number.`,
        "number.integer": `Min Value must be an integer.`,
        "number.greater": `Min Value must be greater than 0.`,
        "any.required": `Min Value is required.`
    }),
    maxValue: Joi.number().integer().greater(0).required().label("maxValue").messages({
        "number.base": `Max Value must be a number.`,
        "number.integer": `Max Value must be an integer.`,
        "number.greater": `Max Value must be greater than 0.`,
        "any.required": `Max Value is required.`
    }),
}


export const NormAssignSchemaObject = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Group required`,
    }),
    estate: Joi.array().min(1).required().label("Operation Entity").messages({
        "array.min": `Operation Entity is required`,
        "any.required": `Operation Entity is required`,
    }),
    configurationID: Joi.number().invalid(0).required().label("Configuration Name").messages({
        "any.invalid": `Configuration Name is required`,
    }),
    // divisionID: Joi.number().label("Collection Point").messages({
    //     // "any.invalid": `Select Division`,
    //     // "any.required": `Division required`
    // }),
    fromDate: Joi.string().invalid("").required().label("From Date").messages({
        "any.required": `From Date required`,
    }),
    toDate: Joi.string().invalid("").required().label("To Date").messages({
        "any.required": `To Date required`,
    }),
    configurationValue: Joi.string().allow('').pattern(/^[0-9]+$/).optional().label("configurationValue").messages({
        "string.pattern.base": `configurationValue must be a positive integer with no special characters or decimals`,
    }),
    minValue: Joi.number().integer().greater(0).required().label("minValue").messages({
        "number.base": `Min Value must be a number.`,
        "number.integer": `Min Value must be an integer.`,
        "number.greater": `Min Value must be greater than 0.`,
        "any.required": `Min Value is required.`
    }),
    maxValue: Joi.number().integer().greater(0).required().label("maxValue").messages({
        "number.base": `Max Value must be a number.`,
        "number.integer": `Max Value must be an integer.`,
        "number.greater": `Max Value must be greater than 0.`,
        "any.required": `Max Value is required.`
    }),
}